export enum FilterId {
  SortByDisplayContainer = 'SortByDisplayContainer',
  PriceFilterPill = 'PriceFilterPill',
  PropertyTypeFilterPill = 'PropertyTypeFilterPill',
  StarRatingPill = 'StarRatingPill',
  StarRatingQuickPill = 'StarRatingQuickPill',
  ReviewScorePill = 'ReviewScorePill',
  FacilitiesFilterPill = 'FacilitiesFilterPill',
  FreeCancellationPill = 'FreeCancellationPill',
  PayLaterPill = 'PayLaterPill',
  PriceFilterPopover = 'PriceFilterPopover',
  FacilitiesFilterPopover = 'FacilitiesFilterPopover',
  ReviewScoreFilterPopover = 'ReviewScoreFilterPopover',
  ThemesFilterPopover = 'ThemesFilterPopover',
  PropertyTypeFilterPopover = 'PropertyTypeFilterPopover',
  StarRatingFilterPopover = 'StarRatingFilterPopover',
  MealPlansFilterPopover = 'MealPlansFilterPopover',
  BreakfastPill = 'BreakfastPill',
  ReviewScoreQuickPill = 'ReviewScoreQuickPill',
  PetFriendlyPill = 'PetFriendlyPill',
  SwimmingPoolPill = 'SwimmingPoolPill',
  ParkingPill = 'ParkingPill',
  BeachPill = 'BeachPill',
  FamilyPill = 'FamilyPill',
  FreeWifiPill = 'FreeWifiPill',
  RestaurantPill = 'RestaurantPill',
  AirConditionedPill = 'AirConditionedPill',
  AirportShuttlePill = 'AirportShuttlePill',
  NeighborhoodFilterPopover = 'NeighborhoodFilterPopover',
  PropertyBrandFilterPopover = 'PropertyBrandFilterPopover',
  PoolPill = 'PoolPill',
  DealFreezePill = 'DealFreezePill' // Added as a part of c747927f-deal-freeze-srp
}
